import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../typesNew";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => {
  if (state && state.imageUploadState) {
    return state.imageUploadState;
  } else {
    return initialState;
  }
};

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
export const selectPageNo = createSelector([selectDomain], (state) => state.pageNo);
export const selectPageSize = createSelector([selectDomain], (state) => state.pageSize);
export const selectTotalRow = createSelector([selectDomain], (state) => state.totalRow);
export const selectList = createSelector(
  [selectDomain],
  (state) => state.formData
);
